import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import ShareCard from "@/components/ShareCard";
import StoreBadges from "@/components/StoreBadges";

export default function Share() {
  useEffect(() => {
    document.title = "Share Stable-ish · Tell a nurse friend";
  }, []);

  return (
    <main
      className="min-h-screen bg-[#050505] text-white noise"
      data-testid="share-page"
    >
      <div className="max-w-[880px] mx-auto px-5 md:px-10 pt-16 md:pt-24 pb-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.28em] text-white/45 hover:text-[#FF2A2A] transition-colors mb-10"
          data-testid="share-back-link"
        >
          <ArrowLeft size={14} weight="bold" />
          back to home
        </Link>

        <div className="mb-10">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-4">
            § 08 · pass it on
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[0.95]">
            Your unit needs
            <br />
            <span className="italic font-light text-white/70">this too.</span>
          </h1>
          <p className="mt-5 text-base text-white/60 max-w-lg">
            Every ER and ICU floor has that one nurse who&apos;d get real
            value out of a fast clinical assistant. Send it their way — takes
            10 seconds, they get 14 days free.
          </p>
        </div>

        <ShareCard testIdPrefix="share-page" />

        <div className="mt-14 pt-10 border-t border-white/10">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-white/45 mb-4">
            or grab it yourself
          </div>
          <StoreBadges testIdPrefix="share-page-store" source="share-page" />
        </div>
      </div>
    </main>
  );
}
